import RequestService from '../../../services/request-service';

export default class CancelPlacedBetslipRequestService extends RequestService {
  constructor() {
    super();
    this.method = 'post';
    this.endpoint = this.$config.endpoints.cancelPlacedBetslip;
    const { authorizationHeaders, defaultHeaders } = this.$config;
    const { Culture } = defaultHeaders;
    this.postParams = {
      Culture,
      BetSlipGroupID: null,
    };
    this.headers = authorizationHeaders;
  }
}
